export default __webpack_public_path__ + "static/media/home-restaurant-img-16.412f857c.jpg";